<template>
<v-card :flat='flat' >
  <!-- <v-alert :value='!appointment.zoom_meeting_id' type='warning' >
    It looks like there could be some problems with the connection between this
    appointment and Zoom
  </v-alert> -->
  <v-card-title class='subtitle-1 overline pb-0' >
    Online meeting details
    <v-spacer></v-spacer>
    <template v-if='withedit' >
      <v-btn v-if='!editmode' @click='editmode=true' small outline outlined >Edit</v-btn>
      <v-btn v-else @click='editmode=false' small flat text >Cancel</v-btn>
    </template>
  </v-card-title>
  <v-card-text v-if='!editmode'>
      <template v-if='appointment.zoom_meeting_id' >
        <strong>Meeting ID:</strong>
        {{appointment.zoom_meeting_id}}
      </template>
      <copy-text-field
        v-if='appointment.zoom_join_url'
        label='Meeting join url'
        :text-to-copy='appointment.zoom_join_url'
        hint='Your customer will use this to join the meeting' >
      </copy-text-field>
      <copy-text-field
        v-if='appointment.zoom_meeting_password'
        label='Meeting password'
        :text-to-copy='appointment.zoom_meeting_password'
        hint='The password for this meeting' >
      </copy-text-field>
  </v-card-text>
  <v-card-text v-else >
    <manual-online-meeting-form v-model='appointment' >
    </manual-online-meeting-form >
  </v-card-text>
  <v-card-actions v-if='appointment.zoom_meeting_id'>
    <!-- <v-btn flat text >Send meeting info to client
      <v-icon small class='ml-2'>send</v-icon>
    </v-btn> -->
    <v-spacer></v-spacer>
    <v-btn flat text :href='`https://zoom.us/meeting/${appointment.zoom_meeting_id}`'
      target='_blank' >
      View meeting
      <v-icon small class='ml-1' >open_in_new</v-icon>
    </v-btn>
    <v-btn flat text
      :href='appointment.zoom_start_url'
      color='primary'
      target='_blank' >
      Start meeting
      <v-icon small class='ml-1' >open_in_new</v-icon>
    </v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
import CopyTextField from '@/components/ui/CopyTextField'
import ManualOnlineMeetingForm from '@/components/forms/Zoom/ManualOnlineMeetingForm'
export default {
  name: 'ZoomMeetingCard',
  components: {CopyTextField, ManualOnlineMeetingForm},
  props: {
    appointment: { type: Object, required: true },
    editmode: { type: Boolean, default: false },
    withedit: { type: Boolean, default: false },
    flat: { type: Boolean, default: true }
  }
}
</script>



// WEBPACK FOOTER //
// OnlineMeetingCard.vue?91f1cc7a